export const GET_DATA_USER= 'GET_DATA_USER';

export const getDataUser = user => ({
    type: GET_DATA_USER,
    payload: {user}
});